/* eslint-disable sonarjs/no-duplicate-string */
import { RoadmapNode } from './organization';

export const WORKSTREAM_MILESTONE_STATUS = {
  COMPLETE: 'complete',
  IN_PROGRESS: 'in_progress',
  LOCKED: 'locked',
  UNKNOWN: 'unknown',
} as const;

export type Workstream = {
  id: string;
  organization: string;
  title: string;
  description: string | null;
  progress: number;
  plot_groups: string[];
  roadmap_nodes: RoadmapNode[];
  created_at: string;
  modified_at: string;
  indicator_products: string[];
};

/**
 * GET /api/v1/organization/{organization_id}/workstreams/
 */
export const GET_WORKSTREAMS_PATH = 'organization/{organization_id}/workstreams/';
export type GetWorkstreamsRequestPathVariables = { organization_id: string };
export type GetWorkstreamsRequestQueryParams =
  | {
      limit?: number;
      offset?: number;
    }
  | undefined;
export type GetWorkstreamsSuccessDto = Workstream[];
export type GetWorkstreamsErrorDto = Error;

/**
 * GET /api/v1/organization/{organization_id}/workstreams/{workstream_id}/
 */
export const GET_ORGANIZATION_WORKSTREAM_BY_ID_PATH = 'organization/{organization_id}/workstreams/{workstream_id}/';
export type GetOrganizationWorkstreamByIdRequestPathVariables = { organization_id: string; workstream_id: string };
export type GetOrganizationWorkstreamByIdRequestQueryParams = undefined;
export type GetOrganizationWorkstreamByIdSuccessDto = Workstream;
export type GetOrganizationWorkstreamByIdErrorDto = Error;

/**
 * POST /api/v1/organization/{organization_id}/workstreams/
 */
export const POST_WORKSTREAM_PATH = 'organization/{organization_id}/workstreams/';
export type PostWorkstreamRequestPathVariables = { organization_id: string };
export type PostWorkstreamRequestQueryParams = undefined;
export type PostWorkstreamRequestBodyData = {
  title: string;
  description?: string | null;
  plot_groups: string[];
  indicator_products: string[];
  roadmap_nodes: Partial<RoadmapNode>[];
  progress?: number;
};
export type PostWorkstreamSuccessDto = Workstream;
export type PostWorkstreamErrorDto = Error;

/**
 * GET /api/v1/organization/{organization_id}/workstreams/{id}/
 */
export const GET_WORKSTREAM_BY_ID_PATH = 'organization/{organization_id}/workstreams/{id}/';
export type GetWorkstreamByIdRequestPathVariables = { organization_id: string; id: string };
export type GetWorkstreamByIdRequestQueryParams = undefined;
export type GetWorkstreamByIdSuccessDto = Workstream;
export type GetWorkstreamByIdErrorDto = Error;

/**
 * PATCH /api/v1/organization/{organization_id}/workstreams/{id}/
 */
export const PATCH_WORKSTREAM_PATH = 'organization/{organization_id}/workstreams/{id}/';
export type PatchWorkstreamRequestPathVariables = { organization_id: string; id: string };
export type PatchWorkstreamRequestQueryParams = undefined;
export type PatchWorkstreamRequestBodyData = {
  title?: string;
  description?: string | null;
  progress?: number;
  plot_groups?: string[];
  roadmap_nodes?: Partial<RoadmapNode>[];
  indicator_products?: string[];
};
export type PatchWorkstreamSuccessDto = Workstream;
export type PatchWorkstreamErrorDto = Error;

/**
 * DELETE /api/v1/organization/{organization_id}/workstreams/{id}/
 */
export const DELETE_WORKSTREAM_PATH = 'organization/{organization_id}/workstreams/{id}/';
export type DeleteWorkstreamRequestPathVariables = { organization_id: string; id: string };
export type DeleteWorkstreamRequestQueryParams = undefined;
export type DeleteWorkstreamSuccessDto = void;
export type DeleteWorkstreamErrorDto = Error;
